// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { searchWithinStyles } from "@guestsupply/Overrides/Widgets/ProductList/ProductListSearchWithin";
import Close from "@guestsupply/XDL/Icons/Close";
import Search from "@guestsupply/XDL/Icons/Search";
import { xScreen } from "@guestsupply/XDL/Utilities";
import { FormFieldClickable } from "@insite/mobius/FormField";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

searchWithinStyles.wrapper = {
    css: css`
        padding: 8px 8px 0;
        border-top: 1px solid ${getColor("common.border")};
        ${xScreen("lte", "md")} {
            margin: 8px 16px 0;
        }
    `,
};
searchWithinStyles.titleText = {
    size: 12,
    weight: 500,
    lineHeight: "13px",
    css: css`
        display: block;
    `,
};
searchWithinStyles.searchTextField = {
    iconProps: { src: Search },
    cssOverrides: {
        formField: css`
            width: 100%;
            margin-top: 8px;
            ${FormFieldClickable} {
                top: 1px;
                right: -1px;
            }
            
            && input {
                padding: 0 35px 0 9px;

                &:focus {
                    padding: 0 35px 0 9px;
                }
            }
        `,
    },
};

searchWithinStyles.refineWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        margin-bottom: 8px;
        margin-top: 0;
        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};

searchWithinStyles.filterText = {
    variant: "h5",
    as: "p",
    css: css`
        margin: 0;
    `,
};

searchWithinStyles.clearAllLink = {
    icon: {
        iconProps: {
            src: Close,
            size: 8,
            color: "common.ui8",
            css: css`
                margin-right: 8px;
            `,
        },
        position: "left",
    },
    typographyProps: {
        css: css`
            font-size: 12px;
            height: 16px;
            line-height: 18px; // lineHeight wasn't applied as a property
            margin-right: 5px;
        `,
    },
};
